import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PaymentStatus {
    display: flex;
    position: relative;
    gap: 24px;

    &-new .PaymentStatus-icon {
      opacity: 0;
      transform: scale(0);
    }

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      border-radius: 50%;
      background-color: #c1c1c1;

      opacity: 1;
      transform: scale(1);
    }

    &:not(:last-child):after {
      display: block;
      content: '';
      position: absolute;
      top: 40px;
      left: 19px;
      width: 2px;
      height: 100%;
      transition: all ease 10s;
      background-color: #c1c1c1;
    }

    &-info {
      display: flex;
      flex-direction: column;
      gap: 8px;

      &-title {
        font-weight: 500;
        font-size: 18px;
      }

      .DateCell__time {
        color: #000 !important;
        font-weight: 500;
      }
    }
  }

  .PaymentStatus-existing:has(+ .PaymentStatus-new),
  .PaymentStatus-new:has(+ .PaymentStatus-new) {
    &:after {
      animation: 0.5s ease-in line-in;
    }
  }

  .PaymentStatus-new .PaymentStatus-icon {
    animation: icon-in 0.35s ease-out 0.5s forwards;
  }

  @keyframes line-in {
    from {
      height: 0;
    }
    to {
      height: 100%;
    }
  }

  @keyframes icon-in {
    0% {
      opacity: 0;
      transform: scale(0);
    }

    60% {
      opacity: 1;
      transform: scale(1.2);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PaymentStatus-success .PaymentStatus-icon {
      background-color: ${colors.success.hex} !important;

      svg {
        path {
          stroke: ${colors.white.hex} !important;
        }
      }
    }

    .PaymentStatus-failed .PaymentStatus-icon {
      background-color: ${colors.error.hex} !important;

      svg {
        width: 14px;
        height: 14px;

        path {
          fill: ${colors.white.hex} !important;
        }
      }
    }

    .PaymentStatus-processing .PaymentStatus-icon {
      background-color: ${colors.warning.hex} !important;
    }

    .PaymentStatus-verification .PaymentStatus-icon {
      background-color: ${colors.warning.hex} !important;
    }
  `;
};

export { staticStyles, getDynamicStyles };
